import React from 'react';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface ChatMessageContainerProps {
  sender: 'user' | 'agent' | 'system';
  children: React.ReactNode;
}

const ContainerComponent: React.FC<ChatMessageContainerProps> = ({
  sender,
  children,
}) => {
  return <div className={clsx('peptalk-chat-message', sender)}>{children}</div>;
};

export const Container: React.FC<ChatMessageContainerProps> = (
  props: ChatMessageContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatMessageContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
